import { render, staticRenderFns } from "./whby.vue?vue&type=template&id=464888c1&scoped=true"
import script from "./whby.vue?vue&type=script&lang=js"
export * from "./whby.vue?vue&type=script&lang=js"
import style0 from "./whby.vue?vue&type=style&index=0&id=464888c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464888c1",
  null
  
)

export default component.exports